const BE_API = `${process.env.REACT_APP_BE_URL}/api`

export async function fetchAssistant(id) {
    const response = await fetch(`${BE_API}/bots/${id}`);
    if (!response.ok) {
      throw new Error("Failed to fetch data");
    }
    return response.json();
  }